export const RAG_MODEL_OPTIONS = [
    { key: 'auto', label: 'Auto (recommended)' },
    // These keys select provider policies, not a fixed model/version. Runtime
    // configuration and capacity may select a different model or fallback.
    { key: 'openai', label: 'OpenAI' },
    { key: 'gemini', label: 'Google Gemini' },
    { key: 'claude', label: 'Anthropic Claude' },
    { key: 'gemma4', label: 'Local (Qwen / Gemma)' },
];

const RAG_MODEL_KEYS = new Set(RAG_MODEL_OPTIONS.map(option => option.key));

export const normalizeRagModelKey = (value) => {
    const key = String(value || '').toLowerCase().trim();
    return RAG_MODEL_KEYS.has(key) ? key : 'auto';
};
